import { render } from "./QPRDetail.vue?vue&type=template&id=ee86dc52"
import script from "./QPRDetail.vue?vue&type=script&lang=js"
export * from "./QPRDetail.vue?vue&type=script&lang=js"
script.render = render

export default script